import {
  ActionPattern,
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects'
import DOMPurify from 'isomorphic-dompurify'

import { Quizzes } from '../../graphql/Services'
import ApiSagas from '../api/sagas'
import { actions } from '..'

import { selectors } from './redux'

export default class QuizzResultSagas {
  static *init(ctx: any) {
    const { query } = ctx
    const { slug } = query

    const sanitizedSlug = DOMPurify.sanitize(slug)

    const { data: result } = yield call(
      ApiSagas.query,
      Quizzes.queries.quizzByID({
        id: sanitizedSlug,
        first: 6,
        page: 1,
      })
    )

    if (!result) {
      return { error: 404 }
    }

    yield put(actions.quizzResult.setQuizz(result))
    if (result.paginated_recommendations.paginatorInfo.hasMorePages) {
      yield put(actions.quizzResult.setHasMoreRecommendations(true))
    }
  }

  static *loadMoreRecommendations(
    action: ReturnType<typeof actions.quizzResult.loadMoreRecommendations>
  ) {
    const quizz = yield select(selectors.quizz)
    const page = action?.payload?.page ?? 1


    if (!quizz) {
      return { error: 404 }
    }

    const { data: result } = yield call(
      ApiSagas.query,
      Quizzes.queries.quizzByID({
        id: quizz.id,
        first: 6,
        page,
      })
    )

    if (!result) {
      return { error: 404 }
    }

    yield put(
      actions.quizzResult.setQuizz({
        ...quizz,
        paginated_recommendations: {
          data: [
            ...quizz.paginated_recommendations.data,
            ...result.paginated_recommendations.data,
          ],
          paginatorInfo: result.paginated_recommendations.paginatorInfo,
        },
      })
    )

    if (!result.paginated_recommendations.paginatorInfo.hasMorePages) {
      yield put(actions.quizzResult.setHasMoreRecommendations(false))
    }
  }

  static *loop() {
    yield all([
      takeLatest(
        actions.quizzResult.loadMoreRecommendations as ActionPattern,
        this.loadMoreRecommendations
      ),
    ])
  }
}
